/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 5/8/15.
 */

function PackageMediaAssetListHeaderController(
    this: JS5Object,
    _: JS5Object,
    PackageMediaService: JS5Object
) {

    this.getTooltip = () => {
        const partnersRequiring = PackageMediaService.getPartnersRequiring(this.type, this.componentRole);

        if (_.size(partnersRequiring)) {
            return 'Required by Partners:<br/>' + _.join(partnersRequiring, '<br/>');
        } else {
            return '';
        }
    };

    this.getTypeLabel = () => {
        const typeLabelMap: JS5Object = {
            video: 'VIDEO',
            'video metadata': 'VIDEO METADATA',
            'ad pod': 'AD POD',
            cc: 'CLOSED CAPTIONING',
            subtitle: 'SUBTITLE',
            audio: 'AUDIO',
            image: 'IMAGE',
            'sdr video': 'SDR VIDEO',
            'hdr video': 'HDR VIDEO'
        };
        return typeLabelMap[this.type];
    };

    this.getValidationStatus = () => {
        return PackageMediaService.getValidationStatus(this.type, this.componentRole);
    };

}

angular.module('prism-ui.package').component('packageMediaAssetListHeader', {
    controller: PackageMediaAssetListHeaderController,
    templateUrl: 'package/editor/components/view/media/assetList/header/package-media-asset-list-header-template.html',
    bindings: {
        componentRole: '<',
        ingestPercent: '<',
        type: '<',
    }
});
